<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-cog"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ 'configuracao-geral.texts.titulo' | translate }}</h1>
    <p class="header-subtitle">{{ 'configuracao-geral.texts.subtitulo' | translate }}</p>
  </div>
</div>

<!-- TabView -->
<div class="tabs-container">
  <p-tabView [(activeIndex)]="activeTabIndex">
    <!-- Aba 1: Cadastro (apenas master) -->
    <p-tabPanel *ngIf="isMaster">
      <ng-template pTemplate="header">
        <i class="pi pi-plus-circle tab-icon"></i>
        <span>{{ 'configuracao-geral.texts.aba_cadastro' | translate }}</span>
      </ng-template>

      <div class="form-card">
        <div class="card-header">
          <div class="card-header-icon">
            <i class="pi pi-plus-circle"></i>
          </div>
          <span class="card-header-title">{{ 'configuracao-geral.texts.dados_configuracao' | translate }}</span>
        </div>
        <div class="card-content">
          <div class="form-grid">
            <!-- Moeda padrao -->
            <div class="form-field half">
              <label class="form-label">{{ 'configuracao-geral.labels.moeda_padrao' | translate }}</label>
              <p-dropdown [options]="moedaOptions" optionLabel="label" optionValue="value"
                [(ngModel)]="form.moedaPadrao" [filter]="true" filterBy="label"
                [placeholder]="'configuracao-geral.placeholders.selecione' | translate"
                appendTo="body" styleClass="w-full">
              </p-dropdown>
            </div>

            <!-- Tipo de gasto especial padrao -->
            <div class="form-field half">
              <label class="form-label">
                {{ 'configuracao-geral.labels.tipo_gasto_especial_padrao' | translate }} <span class="required">*</span>
              </label>
              <p-dropdown [options]="tipoDespesaOptions" optionLabel="nome" optionValue="enum"
                [(ngModel)]="form.tipoDespesaEspecialPadrao" [filter]="true" filterBy="nome"
                [class.error-field]="isFormSubmitted && !form.tipoDespesaEspecialPadrao"
                [placeholder]="'configuracao-geral.placeholders.selecione' | translate"
                appendTo="body" styleClass="w-full">
              </p-dropdown>
            </div>

            <!-- Venda a vista -->
            <div class="form-field half">
              <label class="form-label">
                {{ 'configuracao-geral.labels.venda_a_vista' | translate }} <span class="required">*</span>
              </label>
              <p-dropdown [options]="vendaOptions" optionLabel="label" optionValue="value"
                [(ngModel)]="form.vendaAVista" [filter]="true" filterBy="label"
                [class.error-field]="isFormSubmitted && !form.vendaAVista"
                [placeholder]="'configuracao-geral.placeholders.selecione' | translate"
                appendTo="body" styleClass="w-full">
              </p-dropdown>
            </div>

            <!-- Venda a prazo -->
            <div class="form-field half">
              <label class="form-label">
                {{ 'configuracao-geral.labels.venda_a_prazo' | translate }} <span class="required">*</span>
              </label>
              <p-dropdown [options]="vendaOptions" optionLabel="label" optionValue="value"
                [(ngModel)]="form.vendaAPrazo" [filter]="true" filterBy="label"
                [class.error-field]="isFormSubmitted && !form.vendaAPrazo"
                [placeholder]="'configuracao-geral.placeholders.selecione' | translate"
                appendTo="body" styleClass="w-full">
              </p-dropdown>
            </div>

            <!-- Tipo padrao nota comum -->
            <div class="form-field half">
              <label class="form-label">{{ 'configuracao-geral.labels.tipo_nota_comum' | translate }}</label>
              <p-dropdown [options]="tipoNotaOptions" optionLabel="label" optionValue="value"
                [(ngModel)]="form.tipoPadraoNotaComum" [filter]="true" filterBy="label"
                [placeholder]="'configuracao-geral.placeholders.selecione' | translate"
                appendTo="body" styleClass="w-full">
              </p-dropdown>
            </div>

            <!-- Tipo padrao nota fiscal -->
            <div class="form-field half">
              <label class="form-label">{{ 'configuracao-geral.labels.tipo_nota_fiscal' | translate }}</label>
              <p-dropdown [options]="tipoNotaOptions" optionLabel="label" optionValue="value"
                [(ngModel)]="form.tipoPadraoNotaFiscal" [filter]="true" filterBy="label"
                [placeholder]="'configuracao-geral.placeholders.selecione' | translate"
                appendTo="body" styleClass="w-full">
              </p-dropdown>
            </div>

            <!-- Tipo imprimir -->
            <div class="form-field half">
              <label class="form-label">{{ 'configuracao-geral.labels.tipo_imprimir' | translate }}</label>
              <p-dropdown [options]="tipoImprimirOptions" optionLabel="label" optionValue="value"
                [(ngModel)]="form.tipoPadraoImprimir" [filter]="true" filterBy="label"
                [placeholder]="'configuracao-geral.placeholders.selecione' | translate"
                appendTo="body" styleClass="w-full">
              </p-dropdown>
            </div>

            <!-- Unidade de medida padrao (somente leitura) -->
            <div class="form-field half">
              <label class="form-label">{{ 'configuracao-geral.labels.unidade_medida_padrao' | translate }}</label>
              <input type="text" pInputText [ngModel]="form.unidadeMedidaPadrao" [readonly]="true"
                [placeholder]="'configuracao-geral.placeholders.definida_em_unidade' | translate"
                class="w-full" />
            </div>

            <!-- Versao do app (Android) -->
            <div class="form-field half">
              <label class="form-label">{{ 'configuracao-geral.labels.versao' | translate }}</label>
              <input type="text" pInputText [(ngModel)]="form.versao"
                [placeholder]="'configuracao-geral.placeholders.versao' | translate"
                class="w-full" />
            </div>

            <!-- Versao do app (iOS) -->
            <div class="form-field half">
              <label class="form-label">{{ 'configuracao-geral.labels.versao_apple' | translate }}</label>
              <input type="text" pInputText [(ngModel)]="form.versaoApple"
                [placeholder]="'configuracao-geral.placeholders.versao_apple' | translate"
                class="w-full" />
            </div>

            <!-- URL do video de boas-vindas -->
            <div class="form-field half">
              <label class="form-label">{{ 'configuracao-geral.labels.url_video_boas_vindas' | translate }}</label>
              <input type="text" pInputText [(ngModel)]="form.urlVideoDeBoasVidas"
                [placeholder]="'configuracao-geral.placeholders.url_video_boas_vindas' | translate"
                class="w-full" />
            </div>

            <!-- Exibir video de boas-vindas -->
            <div class="form-field half">
              <label class="form-label">{{ 'configuracao-geral.labels.exibir_video_boas_vindas' | translate }}</label>
              <div class="switch-field">
                <p-inputSwitch [(ngModel)]="form.exibirVideoDeBoasVindas"></p-inputSwitch>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botoes de Acao -->
      <div class="actions-container">
        <button *ngIf="form.id" pButton [label]="'configuracao-geral.botoes.limpar' | translate"
          icon="pi pi-eraser" (click)="limparForm()" class="btn-secondary">
        </button>
        <button *ngIf="!form.id" pButton [label]="'configuracao-geral.botoes.adicionar' | translate"
          icon="pi pi-check" (click)="submit()" [disabled]="submitting" [loading]="submitting" class="btn-primary">
        </button>
        <button *ngIf="form.id" pButton [label]="'configuracao-geral.botoes.salvar' | translate"
          icon="pi pi-check" (click)="submit()" [disabled]="submitting" [loading]="submitting" class="btn-primary">
        </button>
      </div>
    </p-tabPanel>

    <!-- Aba 2: Lista -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-list tab-icon"></i>
        <span>{{ 'configuracao-geral.texts.aba_lista' | translate }}</span>
      </ng-template>

      <div class="table-card">
        <div class="card-header">
          <div class="card-header-icon table-icon">
            <i class="pi pi-list"></i>
          </div>
          <span class="card-header-title">{{ 'configuracao-geral.texts.lista_configuracoes' | translate }}</span>
          <div class="card-header-actions" *ngIf="isMaster">
            <button pButton [label]="'configuracao-geral.botoes.nova' | translate" icon="pi pi-plus"
              (click)="nova()" class="btn-primary btn-sm"></button>
          </div>
        </div>
        <div class="card-content">
          <p-table [value]="configuracoes" [loading]="loading" [tableStyle]="{ 'width': '100%' }">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 22%">{{ 'configuracao-geral.labels.moeda_padrao' | translate }}</th>
                <th style="width: 22%">{{ 'configuracao-geral.labels.unidade_medida_padrao' | translate }}</th>
                <th style="width: 24%">{{ 'configuracao-geral.labels.tipo_gasto_especial_padrao' | translate }}</th>
                <th style="width: 18%">{{ 'configuracao-geral.labels.atualizado_em' | translate }}</th>
                <th *ngIf="isMaster" style="width: 14%">{{ 'configuracao-geral.labels.acoes' | translate }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
              <tr>
                <td>{{ moedaLabel(item.moedaPadrao) }}</td>
                <td>{{ item.unidadeMedidaPadrao }}</td>
                <td>{{ tipoDespesaLabel(item.tipoDespesaEspecialPadrao) }}</td>
                <td>{{ formatarDataEHora(item.atualizadoEm) }}</td>
                <td *ngIf="isMaster" class="actions">
                  <button pButton icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-sm"
                    [pTooltip]="'configuracao-geral.tooltips.editar' | translate" tooltipPosition="top"
                    (click)="editar(item)">
                  </button>
                  <button pButton icon="pi pi-trash"
                    class="p-button-text p-button-rounded p-button-sm p-button-danger"
                    [pTooltip]="'configuracao-geral.tooltips.excluir' | translate" tooltipPosition="top"
                    (click)="confirmarExcluir(item)">
                  </button>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="isMaster ? 5 : 4" class="text-center p-5">
                  <div class="flex flex-column align-items-center">
                    <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                    <div class="text-gray-500 text-lg">{{ 'configuracao-geral.texts.nenhuma_configuracao' | translate }}</div>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="loadingbody">
              <tr>
                <td [attr.colspan]="isMaster ? 5 : 4" class="text-center p-5">
                  <div class="flex justify-content-center align-items-center">
                    <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                    <span class="ml-3">{{ 'configuracao-geral.texts.carregando' | translate }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>

<!-- Dialog de Confirmacao de Exclusao (Wave Pattern) -->
<p-dialog
  [(visible)]="deleteDialogVisible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '30rem' }">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-trash" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'common.confirmacao' | translate }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ 'configuracao-geral.texts.confirmar_exclusao' | translate }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="'common.cancelar' | translate" class="p-button-secondary"
      (click)="deleteDialogVisible = false"></button>
    <button pButton [label]="'common.confirmar' | translate" icon="pi pi-trash"
      style="gap: 0.35rem" (click)="excluir()"></button>
  </ng-template>
</p-dialog>

<p-toast />
